import doorState from 'config/doorState';

export const DOOR_STATE_FILTER_OPTIONS = [
  {
    label: 'All Doors',
    value: '',
  },
  {
    label: 'Favorites',
    value: 'FAVORITES',
  },
  {
    label: 'Empty',
    value: doorState.EMPTY,
  },
  {
    label: 'Not Started',
    value: doorState.NOT_STARTED,
  },
  {
    label: 'In Progress',
    value: 'IN_PROGRESS',
  },
  {
    label: 'Stopped',
    value: doorState.STOPPED,
  },
  {
    label: 'Finished',
    value: doorState.FINISHED,
  },
];

export const DASHBOARD_FILTER_OPTIONS = [
  {
    title: 'Progress',
    items: [
      { label: 'All', value: 'progress_' },
      { label: '0-25%', value: 'progress_0' },
      { label: '26-50%', value: 'progress_1' },
      { label: '51-75%', value: 'progress_2' },
      { label: '76-100%', value: 'progress_3' },
    ],
  },
  {
    title: 'Speed',
    items: [
      { label: 'All', value: 'speed_' },
      { label: 'Slow', value: 'speed_slow' },
      { label: 'Normal', value: 'speed_normal' },
      { label: 'Fast', value: 'speed_fast' },
    ],
  },
  {
    title: 'Process',
    items: [
      { label: 'All', value: 'direction_' },
      { label: 'Inbound', value: 'direction_inbound' },
      { label: 'Outbound', value: 'direction_outbound' },
    ]
  }
];

export const DASHBOARD_SORT_OPTIONS = [
  {
    title: 'Sort by Progress',
    items: [
      { label: 'Higher -> Lower', value: 'progress_desc' },
      { label: 'Lower -> Higher', value: 'progress_asc' },
    ],
  },
  {
    title: 'Sort by Speed',
    items: [
      { label: 'Fast -> Slow', value: 'speed_desc' },
      { label: 'Slow -> Fast', value: 'speed_asc' },
    ],
  },
];
